import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import KubernetesOutlinedSvg from "@ant-design/icons-svg/es/asn/KubernetesOutlined";
import AntdIcon from "../components/AntdIcon";
var KubernetesOutlined = function KubernetesOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: KubernetesOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  KubernetesOutlined.displayName = 'KubernetesOutlined';
}
export default /*#__PURE__*/React.forwardRef(KubernetesOutlined);